const findRankableField = (questions) => {
  const index = questions.findIndex((question) => question.isValidateInput === 'number');
  return {
    isRankable: index !== -1,
    rankableFieldIndexNumber: index,
  };
};

export default findRankableField;
